import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { ConsultationProcessService } from './consultation-process.service';

@Component({
    templateUrl: 'consultation-process.component.html',
    providers: [ConsultationProcessService]
})

export class ConsultationProcessComponent implements OnInit {
    constructor( private activeRouter: ActivatedRoute
        ) { }

    ngOnInit() {
       
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/consultation-process.component.ts